import { render, staticRenderFns } from "./wage-setting.vue?vue&type=template&id=16b5531a&scoped=true"
import script from "./wage-setting.vue?vue&type=script&lang=js"
export * from "./wage-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5531a",
  null
  
)

export default component.exports